import { RolesUsuario } from './../enumeraciones/roles-usuario.enum';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { LoginModel } from '../models/login.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, retry } from 'rxjs/operators';
import { HandleError, HttpErrorHandler } from './handle-error.service';
import { ResponseServiceModel } from '../models/response-service.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { TipoPrestador } from '../enumeraciones/tipo-prestador.enum';
import { EnviromentGlobalService } from './enviroment-global.service';
import { IEncuestaRequest, IEncuestaResponse } from '../models/encuesta.model';


@Injectable()
export class AuthService {
	private helper = new JwtHelperService();
	private API_URL;
	private handleError: HandleError;
	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private router: Router, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
		this.handleError = httpErrorHandler.createHandleError('AuthService');
	}

	login(user_name, clave_acceso): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/usuario/login`,
			{ user_name, clave_acceso }).pipe(
				retry(2)
			);
	}
	validarCambioContrasena(): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/usuario/validarcambiocontrasena`,
			{}).pipe(
				retry(2)
			);
	}
	validarEncuestaSatisfaccion(body: IEncuestaRequest): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/EncuestaSatisfaccion/EncuestaDisponible`,body).pipe(
				retry(0)
			);
	}
	enviarEncuestaSatisfaccion(body: IEncuestaResponse): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/EncuestaSatisfaccion/GuardarDatosEncuestaDisponible`,body).pipe(
				retry(2)
			);
	}
	getToken(): LoginModel {
		return JSON.parse(sessionStorage.getItem('token'));
	}
	
	setToken(loginModel: LoginModel): boolean {
		try {
			sessionStorage.setItem('token', JSON.stringify(loginModel));
			return true;
		} catch (error) {
			return false;
		}
	}

	isToken(): boolean {
		try {
			const token = JSON.parse(sessionStorage.getItem('token')).token;
			return token != null && token !== undefined && !this.helper.isTokenExpired(token);
		} catch (error) {
			return false;
		}
	}

	validarKey(key: string): Observable<boolean> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/usuario/RecuperarClave/Validar`, { key }).pipe(
			retry(2),
			map(resultado => {
				if (resultado.result) {
					this.setToken(resultado.data as LoginModel);
				} else {
					this.router.navigate(['/home']);
				}
				return resultado.result;
			})
		);
	}

	getUserNameToken(): string {
		try {
			const token = JSON.parse(sessionStorage.getItem('token')).token;
			return this.helper.decodeToken(token).unique_name;
		} catch (error) {
			return null;
		}
	}

	getTipoUser(): RolesUsuario {
		try {
			const token = JSON.parse(sessionStorage.getItem('token')).token;
			return this.helper.decodeToken(token).typ;
		} catch (error) {
			return null;
		}
	}
	getRolUser(rol: RolesUsuario): RolesUsuario {
		try {
			const token = JSON.parse(sessionStorage.getItem('token')).token;
			const roles = this.helper.decodeToken(token).prn.split(',');
			return roles.indexOf(rol) >= 0 ? rol : null;
		} catch (error) {
			return null;
		}
	}
	getCamaraUser(): string {
		try {
			const token = JSON.parse(sessionStorage.getItem('token')).token;
			return this.helper.decodeToken(token).codigo_camara;
		} catch (error) {
			return null;
		}
	}
	getRolDetalleUser(): TipoPrestador {
		try {
			const token = JSON.parse(sessionStorage.getItem('token')).token;
			return this.helper.decodeToken(token).sid;
		} catch (error) {
			return null;
		}
	}
	get logoCamaraUser() {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/ContenidoCertificado/ContenidoCertificado`,
			{ codigo_camara: this.getCamaraUser(), contenido_certificado_id: 'LOGO_CAMARA' }).pipe(
				retry(2)
			);
	}
	logout() {
		sessionStorage.clear();
	}
	sincronizar(): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/Prestador/Sincronizacion`, {}).pipe(
			retry(2)
		);
	}
	
}
